import axios from "axios";
import { randomUuidV4 } from "../utils/randomUuidV4";
import config from "../config";
import authHeader from "./auth-header";
import { buildClientHistoryListRequest } from "./clientHistoryRequest";

const API_URL = config.API_URL;


const view = (values = {}) => {
  const request = buildClientHistoryListRequest("afterlogin/client/clientsubscription", values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};


const pendingCancellationKeys = new Map();
const cancelsubscription = (values) => {
  const body = { client_id: Number(values.client_id), id: Number(values.id) };
  const fingerprint = JSON.stringify(body);
  const key = pendingCancellationKeys.get(fingerprint) || randomUuidV4();
  pendingCancellationKeys.set(fingerprint, key);
  return axios.post(API_URL + "afterlogin/client/clientsubscriptioncancel", body, {
    headers: { ...authHeader(), "Idempotency-Key": key },
  }).then(response => {
    pendingCancellationKeys.delete(fingerprint);
    return response;
  });
};


const clientsubscriptionApiController = {
  view,
  cancelsubscription,
};
export default clientsubscriptionApiController;
